<template lang="pug">
v-dialog.advanced-keys(
  v-model="dialog",
  width="500",
)
  template(v-slot:activator="{ on, attrs }")
    g-btn.advanced-keys.background.h9.primary--text(
      height="38px",
      width="150px",
      v-bind="attrs"
      v-on="on"
    ) {{ $t('Chart.advancedKeys') }}
  v-card
    v-card-title {{ $t('Chart.advancedKeys') }}
    v-card-text
      template(v-for="field in options")
        key-group(@input="$emit('input', $event)", v-bind="{ value, field }", :key="field.name")
</template>

<script>
import KeyGroup from '@/components/Chart/KeyGroup';

export default {
  components: {
    KeyGroup,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    options: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    dialog: false,
  }),
}
</script>
